import classNames from 'classnames';
import React from 'react';
import styles from './ContainerContent.module.scss';

interface ContainerProps extends React.HTMLProps<HTMLDivElement> {}

export const ContainerContent = (props: ContainerProps) => {
  const { children, className, ...rest } = props;
  const containerClass = classNames(styles.container, className);

  return (
    <div {...rest} className={containerClass}>
      {children}
    </div>
  );
};
ContainerContent.defaultProps = {};
